 const BASE_API_ENDPOINT = 'https://minigolf-backend.fly.dev/api/weddie-site/';
const API_ENDPOINT = BASE_API_ENDPOINT + 'send-email';
const TOKEN_ENDPOINT = BASE_API_ENDPOINT + 'token';

const AUTH_TOKEN = 'a3ZCanNsVHJ3cThEejlKc3c2RFhVM3M1YjQxcURyWTE2UVUyaDBQT3d3enFQQzhaY2JhWHBZejVWclJidUdhb2EwUVFaZkQ4Qnh4b0dERVlGY1ZrUlhRaEtFb25QUWJReTJHSDBJOElWbDJHMWxTaDU2TE9QYjl5NTZ2SnA4dGI';

interface EmailRequestData {
    sentTo: string;
    sentFrom: string;
    topic: string;
    message: string;
    html: string;
}

interface TokenResponse {
    token: string;
}

export const getSupertoken = async (): Promise<TokenResponse> => {
    try {
        const response = await fetch(TOKEN_ENDPOINT, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${AUTH_TOKEN}`,
            },
        });
        
        if (!response.ok) {
            throw new Error(`Error ${response.status}: ${response.statusText}`);
        }
        
        const data: TokenResponse = await response.json();
        return data;
    } catch (error) {
        console.error('Error getting supertoken:', error);
        throw error;
    }
};

export const sendEmail = async (emailData: EmailRequestData): Promise<Response> => {
    try {
        const response = await fetch(API_ENDPOINT, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${AUTH_TOKEN}`,
            },
            body: JSON.stringify(emailData),
        });
        
        if (!response.ok) {
            throw new Error(`Error ${response.status}: ${response.statusText}`);
        }
        
        return response;
    } catch (error) {
        console.error('Error sending email:', error);
        throw error;
    }
};

/**
 * Creates HTML content for the email
 * @param contact Contact information (email or phone)
 * @param message Message content
 * @returns HTML string for the email body
 */
export const createEmailHtml = (contact: string, message: string): string => {
    const html = `
        <!DOCTYPE html>
        <html>
        <head>
            <style>
                body { font-family: Arial, sans-serif; line-height: 1.6; color: #333; }
                .container { max-width: 600px; margin: 0 auto; padding: 20px; }
                .header { background-color: #C45526; color: white; padding: 10px 20px; border-radius: 5px 5px 0 0; }
                .content { background-color: #f9f9f9; padding: 20px; border-radius: 0 0 5px 5px; }
                .field { margin-bottom: 20px; }
                .label { font-weight: bold; margin-bottom: 5px; }
                .value { padding: 10px; background-color: white; border-radius: 3px; border: 1px solid #ddd; }
                .footer { margin-top: 20px; font-size: 12px; color: #777; }
            </style>
        </head>
        <body>
            <div class="container">
                <div class="header">
                    <h2>New Contact Form Submission</h2>
                </div>
                <div class="content">
                    <div class="field">
                        <div class="label">Contact:</div>
                        <div class="value">${contact}</div>
                    </div>
                    <div class="field">
                        <div class="label">Message:</div>
                        <div class="value">${message.replace(/\n/g, '<br>')}</div>
                    </div>
                </div>
                <div class="footer">
                    <p>This email was sent from the Weddie Site contact form.</p>
                </div>
            </div>
        </body>
        </html>
    `;
    return html.replace(/\n/g, '');
};

/**
 * Email validation regex
 * @param email Email to validate
 * @returns True if email is valid, false otherwise
 */
export const validateEmail = (email: string): boolean => {
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
};

/**
 * Phone validation regex (simple version)
 * @param phone Phone number to validate
 * @returns True if phone number is valid, false otherwise
 */
export const validatePhone = (phone: string): boolean => {
    const re = /^[+]?[(]?[0-9]{3}[)]?[-\s.]?[0-9]{3}[-\s.]?[0-9]{3,6}$/;
    return re.test(String(phone));
};
